var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ margin: _vm.margin})},[_c('router-link',{attrs:{"to":_vm.link}},[_c('el-button',{attrs:{"size":"small","icon":"fas fa-arrow-left"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }